<template lang="pug">
  CardView(
    v-if='genre'
    type='genre'
    :id='genre.id'
    :cover='genre.cover'
    :show-controls='false'
    :title='genre.name || $l10n("NO_NAME")'
    :link='link'
  )

</template>

<script>
import CardView from "@/components/CardView/CardView";

export default {
  inheritAttrs: false,
  name: "GenreCardView",
  props: {
    genre: Object
  },
  computed: {
    link() {
      return this.genre.target
        ? `/genres/${this.genre.id}/${this.genre.target}`
        : `/genres/${this.genre.id}`;
    }
  },
  components: {
    CardView
  }
};
</script>
